import { printVariable } from "@util/helper"
import { useEffect, useState, useRef } from "react"
import consoleLogger from "react-terminal-logger/console-logger"
import { debounce, throttle } from 'lodash';

const useForm = ({initialValues, onSubmit, validate}) => {
  const [values, set_values] = useState(initialValues)
  const [errors, _set_errors] = useState({})
  const errorsRef = useRef(errors)

  const [formLoading, set_formLoading] = useState(false)
  const typingTimeoutRef = useRef(null)

  const set_errors = (errs) => {
    errorsRef.current = errs
    _set_errors(errs)
  }

  // const debouncedUpdateState = debounce(event => {
  //   doHandleChange(event)
  // }, 300);


  // const throttledUpdateState = throttle(event => {
  //   doHandleChange(event)
  // }, 300);

  // const handleChange = async(event) => {
  //   debouncedUpdateState(event)
  // }

  const handleChange = async (event) => {
    let err
    if(event) {
      const name = event.target.name
      const value = event.target.value
      const newValues = {...values}
      newValues[name] = value
      set_values(newValues)
      // set_values({...values, [name]: value})

      if(typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current)
        typingTimeoutRef.current = null
      }

      // error, 500 delay
      // typingTimeoutRef.current = setTimeout( async ()=> {
      //   const err = await validate(name, value)
      //   const newErrors = {...errorsRef.current}
      //   newErrors[name] = err
      //   set_errors(newErrors)
      // }, 500)

      // error, no delay
      err = await validate(name, value)
      const newErrors = {...errorsRef.current}
      newErrors[name] = err
      set_errors(newErrors)
      //
    }
    else {
      const newValues = {...values}
      set_values(newValues)
      const newErrors = {...errorsRef.current}
      set_errors(newErrors)
    }
    return err
  }

  const handleSubmit = async(event) => {
    event.preventDefault()
    const newErrors = {...errors}

    // 필드 입력 값 체크
    let keys = Object.keys(values)
    for(let i = 0; i < keys.length; i++ ) {
      const key = keys[i]
      const err = await validate(key, values[key])
      console.log(`validate value name:${key} value:${values[key]} err:${err}`)
      newErrors[key] = err
    }

    
    let errCount = 0

    // 필드 입력 만으로는 알 수 없는 에러 체크 
    errCount = Object.values(newErrors).filter(r => r).length
    // TODO
    // if(errCount === 0) {
    if(1 == 1) {
      const error = await validate('error', '')
      newErrors.error  = error
    }

    set_errors(newErrors)

    // 에러 없으면 onSubmit 으로 넘기기
    errCount = 0
    
    keys = Object.keys(newErrors)
    
    for(let i = 0; i < keys.length; i++) {
      const key = keys[i]
      if(newErrors[key]) {
        console.log(`key:${key} err:${errors[key]}`)
        errCount = errCount + 1
      }
    }

    console.log(`errCount:${errCount}`)
    if(errCount === 0) {
      onSubmit()
    }
  }

  useEffect(() => {
  }, [])

  return [values, errors, formLoading, handleChange, handleSubmit]
}

export default useForm
